import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { CurrentClientUserClientApiDataTransformer } from '@client/entity/current-client-user/data/transformer/current-client-user-client.api-data-transformer';
import type { CurrentClientUserApiData } from '@client/entity/current-client-user/data/api-data/current-client-user.api-data';
import { CurrentClientUser } from '@client/entity/current-client-user/domain/model/current-client-user.model';
import type { ApiDataTransformer } from '@kiplin/web-common/architecture-core';
import { inject, injectable } from 'inversify';
import { CurrentUserDependencyTypes } from '@shared/entity/current-user/current-user.dependency-types';
import type { CurrentUserApiDataTransformer } from '@shared/entity/current-user/data/transformer/current-user.api-data-transformer';
import { CurrentUserIsNotAClientError } from '@client/entity/current-client-user/domain/error/current-user-is-not-a-client.error';
import { CurrentUserApiDataUserType } from '@shared/entity/current-user/data/api-data/current-user.api-data';

@injectable()
export class CurrentClientUserApiDataTransformer implements ApiDataTransformer<
  CurrentClientUserApiData,
  CurrentClientUser
> {
  constructor(
    @inject(CurrentUserDependencyTypes.CurrentUserApiDataTransformer)
    private readonly currentUserApiDataTransformer: CurrentUserApiDataTransformer,
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserClientApiDataTransformer)
    private readonly currentClientUserClientApiDataTransformer: CurrentClientUserClientApiDataTransformer,
  ) {}

  map(data: CurrentClientUserApiData): CurrentClientUser {
    if (data.userType !== CurrentUserApiDataUserType.Client) {
      throw new CurrentUserIsNotAClientError();
    }

    const currentUser = this.currentUserApiDataTransformer.map(data);

    return new CurrentClientUser(
      currentUser.id,
      currentUser.email,
      currentUser.firstname,
      currentUser.lastname,
      data.clients?.map((client) => this.currentClientUserClientApiDataTransformer.map(client)) ?? [],
    );
  }
}
